export interface IUserSettingsData {
  id: string;
  settings: IUserAccountSettings[]
}

interface IUserAccountSettings {
  rsrcId: string,
  id: string,
  type: string,
  name: string,
  isEnabled: boolean,
  scopeId: string,
  updtAt?: string,
  updtBy: string,
  unitsInfo?: UnitsInfo[],
  value: IUserAccountPreferences
}

interface UnitsInfo {
  MeasurementType: string;
  UnitName: string;
  unitFriendlyName: string;
  unitPrecision: number;
}

export interface IUserAccountPreferences {
  prefs: IUserAccountPreference[]
}

export interface IUserAccountPreference {
  name: string,
  value: string
}

export interface IUserProfile {
  createdAt: string;
  createdBy: string;
  dataPrivacyAcceptedVersion: string;
  displayName: string;
  email: string;
  emailOtpGeneratedOn: string;
  emailVerified: boolean;
  eulaAcceptedVersion: string;
  firstName: string;
  id: string;
  lastModifiedBy: string;
  lastModifiedOn: string;
  lastName: string;
  phone: string;
  phoneOtpGeneratedOn: string;
  phoneVerified: boolean;
  registrationStatus: string | null;
  roles: string | null;
  userSettings: any[];
  userWorkgroups: any[];
}

export enum EUserPersonalisation {
  language = 'language',
  dateFormat = 'dateFormat',
  timeFormat = 'timeFormat',
  unitSystem = 'unitSystem',
  theme = 'theme',
}

export enum URLSource {
  Titan = 'titan',
}
